import angular from 'angular';
import { AJS_MODULE_NAME } from '@common/constants';
import * as Enums from '@app/enums';
import * as EnumsUli from '@app/constants';
import { environment } from '@environments/environment';

angular
	.module(AJS_MODULE_NAME)
	.constant('ACCOUNT_TYPES', Enums.AccountType)
	.constant('ACH_SETUP', Enums.AchSetup)
	.constant('ACH_SETUP_ARRAY', Enums.AchSetupArray)
	.constant('AC_LIST_NAMES', Enums.AclListName)
	.constant('AR_INVOICE_STATUS', Enums.ARInvoiceStatus)
	.constant('BUSY_MESSAGE', Enums.BusyMessage)
	.constant('DEDUCTION_FREQUENCY', Enums.DeductionFrequency)
	.constant('DEDUCTION_TYPES', Enums.DeductionTypes)
	.constant('DOCUMENT_TYPES', Enums.DocumentType)
	.constant('DOCUMENT_STATES', Enums.DocMgmtContentStateEnum)
	.constant('EMPHOURS_AUDIT', Enums.EmployeeHoursAudit)
	.constant('EMP_STATUS', Enums.EmployeeStatus)
	.constant('HOURS_SOURCE', Enums.HoursSource)
	.constant('INVOICE_SEARCH_TYPES', Enums.InvoiceSearchType)
	.constant('INVOICE_STATUS', Enums.InvoiceStatus)
	.constant('JOURNAL_TYPES', Enums.JournalTypes)
	.constant('METHODS_OF_PAYMENT', Enums.MethodsOfPayment)
	.constant('NCCOAIMPORTFILES', Enums.NCCoAImportFiles)
	.constant('OTHER_PAY_TYPES', Enums.OtherPayTypes)
	.constant('PO_STATUS', Enums.POStatus)
	.constant('PR_FLSA_TYPES', Enums.PRFLSATypes)
	.constant('PROCESSING_STATUS', Enums.ProcessingStatus)
	.constant('PR_ORBITPLANCODES', Enums.PROrbitPlanCode)
	.constant('PR_PAY_TYPES', Enums.PRPayTypes)
	.constant('PR_PROCESSING_STATUS', Enums.PRProcessingStatus)
	.constant('PURCHASING_TYPES', Enums.PurchasingTypes)
	.constant('REQUEST_STATUS', Enums.RequestStatus)
	.constant('REQUEST_TYPES', Enums.RequestTypes)
	.constant('ROLE_CLAIMS', Enums.RoleClaims)
	.constant('ROLE_CLAIM_DESCRIPTIONS', Enums.RoleClaimDescription)
	.constant('LEAVE_PAYOUT_PAY_TYPES', Enums.LeavePayoutPayTypes)
	.constant('SOCKETS', {
		url: environment.API_URL,
		hubName: 'SLHub',
	})
	.constant('SOURCE', Enums.Source)
	.constant('STATE_REPORTING', Enums.StateReporting)
	.constant('TAX_RATE_TYPES', Enums.TaxRateTypes)
	.constant('TK_ROUNDING_METHODS', Enums.TKRoundingMethod)
	.constant('VENDOR_STATUS', Enums.VendorStatus)
	.constant('WITHHOLDING', Enums.Withholding)
	.constant('USER_CLAIMS', Enums.UserClaims)
	.constant('USER_CLAIM_TYPES', Enums.UserClaimTypes)
	.constant('UNIT_LIST_ITEM_FIELD_NAMES', EnumsUli.UNIT_LIST_ITEM_FIELD_NAMES)
	.constant('RESPONSE_CODES', Enums.ResponseCodes)
	.constant('DPI_STATUS', EnumsUli.DPIStatus);
